export const adminMenu = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: "bi bi-grid-fill",
  },
  {
    title: "Reporting",
    url: "#",
    icon: "bi bi-graph-up-arrow",
    submenu: [
      {
        title: "Student Fee Summary",
        url: "/dashboard/report/detail/student-fee-summary",
      },
      {
        title: "Total Enquiry",
        url: "/dashboard/report/detail/TotalEnquiry",
      },
      {
        title: "Total Student",
        url: "/dashboard/report/detail/TotalStudent",
      },
      {
        title: "Current Batches",
        url: "/dashboard/report/detail/CurrentBatches",
      },
      {
        title: "Completed Batches",
        url: "/dashboard/report/detail/CompletedBatches",
      },
      {
        title: "Present Student",
        url: "/dashboard/report/detail/PresentStudent",
      },
      {
        title: "Absent Student",
        url: "/dashboard/report/detail/AbsentStudent",
      },
      {
        title: "Due Fees",
        url: "/dashboard/report/detail/DueFees",
      },
      {
        title: "Drop Out",
        url: "/dashboard/report/detail/DropOut",
      },
      {
        title: "Unattended Out",
        url: "/dashboard/report/detail/UnattendedOut",
      },
      {
        title: "Received Amount/Day",
        url: "/report/pay-collection",
      },
    ],
  },
  // {
  //     title: "Reports",
  //     url: "#",
  //     icon: "bi bi-clock-history",
  //     submenu: [
  //          {
  //             title: "Pay Collection",
  //             url: "report/pay-collection",
  //             icon: "bi bi-currency-rupee",
  //         },

  //     ],
  // },

  {
    title: "Enquiry",
    url: "/enquiry",
    icon: "bi bi-patch-question",
  },

  {
    title: "Catagory",
    url: "/course/category",
    icon: "bi bi-tag",
  },
  {
    title: "Course",
    url: "/course",
    icon: "bi bi-mortarboard",
  },
  {
    title: "Batch",
    url: "/batch/list",
    icon: "bi bi-ui-checks-grid",
  },
  {
    title: "Attendance Report",
    url: "report/attendance",
    icon: "bi bi-calendar3",
  },
  {
    title: "Attendance History",
    url: "/attendance/history",
    icon: "bi bi-calendar2-check",
  },
  {
    title: "Admin Users",
    url: "/admin/user/list",
    icon: "bi bi-person-fill",
  },
  {
    title: "Faculty Users",
    url: "/faculty/user/list",
    icon: "bi bi-people",
  },
  {
    title: "Student",
    url: "/student/list",
    icon: "bi bi-people",
  },
];
